// extracted by mini-css-extract-plugin
module.exports = {"Main":"accordion-item_Main__WuRez"};